// Portfolio content. Edit here to update the site.

// Portrait library — add new options here and change `activePortraitId` to swap the hero image.
// `focus` controls the object-position Y anchor so the face stays visible without cropping.
export const portraits = [
  {
    id: "malta",
    label: "Malta Street",
    src: "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/e9jvj62g_5345933209537026414.jpg",
    focus: "center 20%",
  },
  {
    id: "library",
    label: "Library Desk",
    src: "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/zpy5uvmh_5345933209537026723.jpg",
    focus: "center 24%",
  },
  {
    id: "study",
    label: "Study — Green Library",
    src: "https://customer-assets-rejwkqb3.emergentagent.net/job_rudenko-director/artifacts/l84c4aag_IMG_9401.webp",
    // Face sits roughly in the upper third of the frame; anchor object-position
    // so Valeriy's face stays fully visible across all viewports.
    focus: "center 30%",
  },
];

// Change this ID to swap the hero portrait — no layout or styling changes required.
export const activePortraitId = "study";

// Separate portrait for the About/Biography section. Swap freely without touching the hero.
export const aboutPortrait = {
  src: "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/2d4slm1q_5345933209537026768.jpg",
  alt: "Valeriy Rudenko, film director, filming with a Super 8 camera",
};

export const director = {
  name: "Valeriy Rudenko",
  role: "Film Director",
  location: "Based in Europe, available worldwide",
  // Preserved for compatibility with the About section. Points to the current hero portrait.
  portrait:
    (portraits.find((p) => p.id === activePortraitId) || portraits[0]).src,
};

export const biography = [
  "Valeriy Rudenko is a film director based in Europe and available for film projects worldwide.",
  "He graduated from the Faculty of Journalism at Lomonosov Moscow State University while simultaneously pursuing professional film education at the New York Film Academy (Los Angeles), the Moscow Film School, and the \u201cIn the Opening Credits\u201d Screenwriting Academy.",
  "His directing style combines a range of creative approaches, always shaped by the unique needs of each story. He believes every film deserves its own visual language and works closely with actors to create authentic, emotionally engaging performances. Valeriy also prefers to edit his own films, allowing him to preserve the rhythm, atmosphere and creative vision established during production.",
  "Throughout his career, Valeriy has directed projects in both the United States and Russia, gaining experience across different filmmaking environments and productions.",
  "Today, he is expanding his work across Europe and is open to international collaborations in feature films, television, commercials, branded content and narrative productions.",
  "He believes that cinema should not only tell stories, but create emotions that remain with the audience long after the final frame.",
];

// Personal closing statement — rendered as an editorial pull quote in the About section.
export const closingQuote = {
  text: "I believe cinema should not only tell stories, but create emotions that remain with the audience long after the final frame.",
  attribution: "Valeriy Rudenko",
};

export const films = [
  {
    id: "surprise",
    kind: "feature",
    index: "01",
    title: "The Surprise!",
    year: "",
    role: "Writer  ·  Director",
    poster:
      "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/dfuthqk2_5345973337416472998.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/uvgch4uv_5350606606401478290.jpg",
      "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/ytulrln5_5345933209537026487.jpg",
      "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/9mcznep7_5345933209537026489.jpg",
      "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/fblmyeec_5345933209537026490.jpg",
      "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/p1ra49gn_5345933209537026491.jpg",
    ],
    synopsis:
      "A short synopsis of the film will live here. Keep it to two or three restrained sentences — enough to intrigue a festival programmer without giving anything away.",
    trailerUrl: "",
    youtubeUrl: "https://www.youtube.com/watch?v=-tgeSqiJiRQ",
    watchLinks: [
      { label: "Watch on Kinopoisk", url: "https://www.kinopoisk.ru/film/5059109/" },
      { label: "Watch on OKKO", url: "https://okko.tv/movie/sjurpriz-527669733" },
    ],
  },
  {
    id: "shorts",
    kind: "shorts",
    index: "02",
    title: "Short Films",
    year: "",
    role: "Writer  ·  Director",
    stills: [
      { title: "Lighting Solutions", url: "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/dhpyoyk3_5345933209537026476.jpg", link: "https://vimeo.com/487448763" },
      { title: "Enlightenment", url: "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/halvw2fp_5345933209537026471.jpg", link: "https://vimeo.com/73560562" },
      { title: "Moscow, Loneliness, 5 Shots", titleLines: ["Moscow, Loneliness,", "5 Shots"], url: "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/3qy5s1ig_5345933209537026474.jpg", link: "https://vimeo.com/476571782" },
      { title: "Spaces", url: "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/qk3wzhcf_5345933209537026472.jpg", link: "https://vimeo.com/481497745" },
      { title: "Personal Point", url: "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/4xuzv6wp_5345933209537026473.jpg", link: "https://vimeo.com/72571076" },
      { title: "Emotion Without a Hero", url: "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/d8yl94xz_5345933209537026475.jpg", link: "https://vimeo.com/485250295" },
    ],
    synopsis:
      "A selection of short films developed and directed by Valeriy Rudenko. Titles, synopses, festivals and awards to be added.",
    selections: [],
    awards: [],
    trailerUrl: "",
  },
];

export const behindTheScenes = {
  index: "03",
  title: "Behind the Scenes",
  subtitle: "On set — process, collaboration and craft.",
  // Behind-the-scenes photographs from various productions.
  images: [
    "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/udyam0wo_5339271345893743748.jpg",
    "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/wx17ydtj_5339271345893743749.jpg",
    "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/gv1kbq9l_5350606606401478373%20%281%29.jpg",
    "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/bvrn6ctk_5350606606401478288.jpg",
    "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/bo15w0pe_5339271345893743752%20%281%29.jpg",
    "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/m649y95t_5339271345893743750%20%281%29.jpg",
    "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/mblqzldb_5350606606401478289.jpg",
    "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/bwf3o2mf_5339271345893743756.jpg",
    "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/f680cy8y_5350606606401478291.jpg",
    "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/j97wo4r3_5350606606401478372%20%281%29.jpg",
  ],
};

export const featureFilm = {
  status: "In Development",
  title: "1861",
  duration: "120 min",
  genre: "Historical Thriller",
  creator: {
    name: "Valeriy Rudenko",
    role: "Director  ·  Screenwriter",
  },
  logline:
    "Tikhomirov, a lowly clerk, forges official documents and sets out for the estate of a ruthless landowner to free his serf father through deception. Along the way, he is robbed by a runaway peasant and unexpectedly drawn into the search for the fugitive alongside the landowner and his entourage. To protect his secret and save his father, Tikhomirov must navigate a dangerous game of lies and survival — until he is forced to choose between saving himself and saving others.",
  poster:
    "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/mbdz5now_5345973337416472999.jpg",
};

export const showreelEmbedUrl = "";
export const showreelVideoUrl =
  "https://customer-assets.emergentagent.com/job_rudenko-director/artifacts/d7f5fwdf_IMG_7019.MP4";

export const contact = {
  email: "valeriyrudenko.director@gmail.com",
  imdb: "https://www.imdb.com/name/nm13977581/?ref_=ext_shr_lnk",
  instagram: "https://www.instagram.com/rudenkoman?igsh=bmkzdmhnOXJoODR4",
};
